import { useEffect } from 'react';

import { type BagDetailedSellerCache } from '@/modules/bag/types';
import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { useCurrentUser } from '@/modules/user/useCurrentUser.ts';

export function useBagSignupPromptExperiment(
  sellers: BagDetailedSellerCache[] | undefined
) {
  const [isAuthenticated] = useCurrentUser();
  const [{ web_9228_bag_signup_prompt }, bucket] = useExperiments(
    ['web_9228_bag_signup_prompt'],
    { deferred: true }
  );

  const hasItems = !!sellers && sellers.length > 0;
  const shouldBucket = hasItems && !isAuthenticated;

  useEffect(() => {
    if (shouldBucket) {
      bucket();
    }
  }, [shouldBucket]);

  return !isAuthenticated && web_9228_bag_signup_prompt === VARIANT_IDENTIFIER;
}
